import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { BtnDefault } from '../common/Buttons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../common/Dropdown';
import { Ellipsis } from 'lucide-react';
import { IClient, IBrand } from '../../types/brand';

interface IClientWithBrands extends IClient {
  brands: IBrand[];
  client: IClient;
}

interface ClientColumnParams {
  onView: (data: IClient) => void;
  onEdit: (data: IClient) => void;
  onAddBrand: (data: IClient) => void;
  onEditBrand: (data: IClient) => void;
  onEditClient: (data: IClient) => void;
  validClient: (clientId: string) => IClient | null;
  setSelectedClient: (client: IClient | null) => void;
  setIsClientInfoModalOpen: (open: boolean) => void;
  handleBrandModalOpen: (client: IClient | null) => void;
}

export const useClientColumns = ({
  onView,
  onEditClient,
  onAddBrand,
  validClient,
}: ClientColumnParams): ColDef<IClientWithBrands>[] => {
  return [
    ...clientColumnsDefs(),
    {
      headerName: 'Actions',
      field: '_id',
      width: 150,
      sortable: false,
      filter: false,
      suppressSizeToFit: true,
      pinned: 'right',
      lockPinned: true,
      cellRenderer: (params: any) => {
        const client = validClient(params.data.client?._id);

        if (!client) return null;

        return (
          <div className="flex justify-center items-center w-full space-x-2">
            <BtnDefault onClick={() => onView(client)}>View</BtnDefault>
            <DropdownMenu>
              <DropdownMenuTrigger>
                <BtnDefault className="!py-1.5 mt-2 !px-4 relative bottom-1">
                  <Ellipsis size={16} />
                </BtnDefault>
              </DropdownMenuTrigger>
              <DropdownMenuContent side="bottom" align="end">
                <DropdownMenuItem onClick={() => onEditClient(client)}>
                  Edit Client
                </DropdownMenuItem>
                <DropdownMenuSeparator className="border-t border-gray-200" />
                <DropdownMenuItem onClick={() => onAddBrand(client)}>
                  Add Brand
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        );
      },
    },
  ];
};

export const clientColumnsDefs = (): ColDef<IClientWithBrands>[] => [
  {
    headerName: 'Client Name',
    field: 'client.businessName',
    valueGetter: (params: ValueGetterParams) => {
      const client = params.data?.client;
      return client?.businessName || client?.name || '';
    },
  },
  {
    headerName: 'Email',
    field: 'client.email',
  },
  {
    headerName: 'Brand Names',
    field: 'brands',
    valueGetter: (params: ValueGetterParams) => {
      if (!params.data) return '';
      return params.data.brands.map((brand: IBrand) => brand.name).join(', ');
    },
  },
];
